import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RelativeTimePipe } from './relative-time.pipe';
import { ExcerptPipe } from './excerpt.pipe';
import { GetValueByKeyPipe } from './get-value-by-key.pipe';
import { HighlightPipe } from '../../highlight.pipe';
import { XmlPipe } from '../../xml.pipe';
import { AuthImagePipe } from '../../auth-image.pipe';
import { Nl2brPipe } from '../../shared/pipes/nl2br.pipe';


const pipes = [
  RelativeTimePipe,
  ExcerptPipe,
  GetValueByKeyPipe,
  HighlightPipe,
  AuthImagePipe,
  XmlPipe,
  Nl2brPipe
]

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: pipes,
  exports: pipes
})
export class SharedPipesModule { }
